import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { PickersLayout } from '@mui/x-date-pickers/PickersLayout';

function CustomLayout(props) {
  return (
    <Box>
      {/* ✅ Custom header injected above the calendar */}
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" align="left">
          {props.label || "Select Date"}
        </Typography>
        <Divider sx={{ mt: 1, bgcolor: "primary.contrastText" }} />
      </Box>

      {/* ✅ Render the default layout below */}
      <PickersLayout
        {...props}
        slotProps={{
          ...props.slotProps,
          toolbar: { hidden: true }, // 👈 removes "SELECT DATE" + date display
        }}
      />
    </Box>
  );
}

export default function DatePickerMui({ label = "Select Date", onChange, ...props }) {
  const [value, setValue] = React.useState(props.value ? props.value : null);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        {...props}
        label={label}
        format="YYYY-MM-DD"
        sx={{ width: "100%" }}
        value={value}
        onChange={(newValue) => {
          if (newValue) {
            const formatted = newValue.format("YYYY-MM-DD");
            setValue(newValue);
            onChange(formatted);
          } else {
            setValue(null);
            onChange("");
          }
        }}
        slots={{
          layout: CustomLayout, // 👈 override layout instead of toolbar
        }}
        slotProps={{
          field: { clearable: true },
          layout: { label }, // pass label down
        }}
      />
    </LocalizationProvider>
  );
}
